import { gql } from "@apollo/client";

export const FETCH_ADMIN_PAGE = gql`
  query FetchAdminPage {
    adminPage {
      adminTabs {
        manageStaff
        reportingTools
      }
    }
  }
`;
